import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../../hooks/redux';
import { appOverlayDisplayConfig, toolbarAndNavDisplayConfig } from '../actions';
import { OverlayDisplayConfigMessageType } from '../interface';
import { selectOverlayDisplayConfig } from '../selectors';
import { OVERLAY_MESSAGE_RECEIVED } from '../../constants/metrics';
import { Metrics } from '../../utils/metrics';
export function isValidOverlayMessageOrigin(inputString) {
  const regex = /(local|app|tools)(-[a-z]+[0-9])?\.(hub(spot|team)(qa)?)\.com/;
  return regex.test(inputString);
}
const isOverlayOpenMessage = event => event.data.id === OverlayDisplayConfigMessageType.OVERLAY_OPEN_MESSAGE;
const isOverlayCloseMessage = event => event.data.id === OverlayDisplayConfigMessageType.OVERLAY_CLOSE_MESSAGE;
export function useHandleNavInappCommMessage() {
  const overlayDisplayConfigState = useAppSelector(selectOverlayDisplayConfig);
  const dispatch = useAppDispatch();
  const overlayOpenMessageHandler = useMemo(() => getOverlayOpenMessageHandler(dispatch, overlayDisplayConfigState), [dispatch, overlayDisplayConfigState]);
  const overlayCloseMessageHandler = useMemo(() => getOverlayCloseMessageHandler(dispatch, overlayDisplayConfigState), [dispatch, overlayDisplayConfigState]);
  useEffect(() => {
    window.addEventListener('message', overlayOpenMessageHandler);
    window.addEventListener('message', overlayCloseMessageHandler);
    return () => {
      window.removeEventListener('message', overlayOpenMessageHandler);
      window.removeEventListener('message', overlayCloseMessageHandler);
    };
  }, [overlayOpenMessageHandler, overlayCloseMessageHandler]);
}
function getOverlayOpenMessageHandler(dispatch, existingOverlayDisplayConfig) {
  return event => {
    if (!event.data) {
      return;
    }
    if (!isOverlayOpenMessage(event) || !isValidOverlayMessageOrigin(event.origin)) {
      return;
    }
    const {
      isInitialized: isOverlayDisplatStateInitialized,
      appName: currentAppName
    } = existingOverlayDisplayConfig;
    const {
      appName,
      overlayType
    } = event.data.payload;
    Metrics.counter(OVERLAY_MESSAGE_RECEIVED, {
      action: 'overlay-open',
      appName
    }).increment();
    if (isOverlayDisplatStateInitialized && appName === currentAppName) {
      return;
    }
    dispatch(appOverlayDisplayConfig({
      appName,
      [overlayType]: {
        shouldShowToolbar: false,
        shouldShowNav: false
      }
    }));
    dispatch(toolbarAndNavDisplayConfig({
      isOverlayOpen: true,
      overlayType
    }));
  };
}
function getOverlayCloseMessageHandler(dispatch, existingOverlayDisplayConfig) {
  return event => {
    var _existingOverlayDispl;
    if (!event.data) {
      return;
    }
    if (!isOverlayCloseMessage(event) || !isValidOverlayMessageOrigin(event.origin)) {
      return;
    }
    Metrics.counter(OVERLAY_MESSAGE_RECEIVED, {
      action: 'overlay-close',
      appName: (_existingOverlayDispl = existingOverlayDisplayConfig.appName) !== null && _existingOverlayDispl !== void 0 ? _existingOverlayDispl : 'unknown'
    }).increment();
    dispatch(toolbarAndNavDisplayConfig({
      isOverlayOpen: false
    }));
  };
}